import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InputSwitch from 'component/utils/newInputSwitch'

class Table extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    justifications: PropTypes.array.isRequired,
    editJustification: PropTypes.func.isRequired,
    removeJustification: PropTypes.func.isRequired,
    updateJustificationIsActive: PropTypes.func.isRequired,
  }

  renderJustifications = (justification) => {
    const {
      editJustification,
      removeJustification,
      updateJustificationIsActive,
    } = this.props

    return (
      <tr key={justification.idJustificationDemarcate}>
        <td className='align-left overflow-hidden-column'>
          {justification.dsJustificationDisapprovalUseConsumption}
        </td>
        <td className='align-center option-width'>
          <InputSwitch
            checked={justification.inInactive === 0}
            onChange={() => {
              updateJustificationIsActive(justification)
            }}
          />
        </td>
        <td className='align-center option-width'>
          <a role='button' onClick={() => editJustification(justification)}>
            <i className='glyph glyph-pencil color-primary' />
          </a>
        </td>
        <td className='align-center option-width'>
          <a role='button' onClick={() => removeJustification(justification)}>
            <i className='glyph glyph-trash-can color-danger' />
          </a>
        </td>
      </tr>
    )
  }

  render() {
    const { justifications, translate } = this.props

    const justificationList = justifications.sort(
      (a, b) => a.dsJustificationDemarcate - b.dsJustificationDemarcate
    )

    return (
      <table className='table table-zebra table-layout-fixed'>
        <thead>
          <tr>
            <th className='align-left'>
              {translate('demarcate.justification.description')}
            </th>
            <th className='align-center option-width'>
              {translate('demarcate.justification.status')}
            </th>
            <th className='align-center option-width'>
              {translate('demarcate.justification.edit')}
            </th>
            <th className='align-center option-width'>
              {translate('demarcate.justification.delete')}
            </th>
          </tr>
        </thead>
        <tbody>{justificationList.map(this.renderJustifications)}</tbody>
      </table>
    )
  }
}

export default Table
